import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Save, Plus, Trash2 } from "lucide-react";

export default function Content() {
  const [s, setS] = useState({ announcement:"", about_text:"", hero_banners:[], instagram:"", whatsapp:"" });
  useEffect(() => { api.get("/settings").then((r)=>setS({...s, ...(r.data||{})})); /* eslint-disable-next-line */ }, []);

  const save = async () => {
    try {
      await api.put("/admin/settings", s);
      toast.success("Conteúdo atualizado!");
    } catch { toast.error("Erro ao salvar"); }
  };

  const addBanner = () => setS({...s, hero_banners:[...(s.hero_banners||[]), {id:Date.now().toString(), title:"", subtitle:"", image:"", cta_text:"Ver coleção", cta_link:"/"}]});
  const updBanner = (i, k, v) => setS({...s, hero_banners: s.hero_banners.map((b,j)=>j===i?{...b,[k]:v}:b)});
  const delBanner = (i) => setS({...s, hero_banners: s.hero_banners.filter((_,j)=>j!==i)});

  return (
    <div className="space-y-5" data-testid="admin-content">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl text-[#4A3B40]">Conteúdo do site</h1>
        <button onClick={save} className="btn-lara" data-testid="content-save"><Save className="w-4 h-4" /> Salvar tudo</button>
      </div>

      <div className="bg-white rounded-2xl border border-[#F9E1E8] p-5">
        <h3 className="font-serif text-lg text-[#4A3B40] mb-3">Barra de anúncio</h3>
        <input className="ct w-full" value={s.announcement||""} onChange={(e)=>setS({...s, announcement:e.target.value})} placeholder="Frete grátis acima de R$ 199..." data-testid="content-announcement" />
      </div>

      <div className="bg-white rounded-2xl border border-[#F9E1E8] p-5">
        <h3 className="font-serif text-lg text-[#4A3B40] mb-3">Sobre a Lara B.</h3>
        <textarea className="ct w-full" rows={4} value={s.about_text||""} onChange={(e)=>setS({...s, about_text:e.target.value})} />
      </div>

      <div className="bg-white rounded-2xl border border-[#F9E1E8] p-5">
        <div className="flex items-center justify-between mb-3">
          <h3 className="font-serif text-lg text-[#4A3B40]">Banners do Hero</h3>
          <button onClick={addBanner} className="btn-lara-soft text-sm py-2 px-3"><Plus className="w-4 h-4" /> Adicionar</button>
        </div>
        <div className="space-y-3">
          {(s.hero_banners||[]).map((b, i) => (
            <div key={i} className="grid md:grid-cols-2 gap-3 border border-[#F9E1E8] rounded-xl p-3">
              <input className="ct" placeholder="Título" value={b.title} onChange={(e)=>updBanner(i,"title",e.target.value)} />
              <input className="ct" placeholder="Subtítulo" value={b.subtitle} onChange={(e)=>updBanner(i,"subtitle",e.target.value)} />
              <input className="ct" placeholder="URL da imagem" value={b.image} onChange={(e)=>updBanner(i,"image",e.target.value)} />
              <div className="flex gap-2">
                <input className="ct flex-1" placeholder="Texto botão" value={b.cta_text||""} onChange={(e)=>updBanner(i,"cta_text",e.target.value)} />
                <input className="ct flex-1" placeholder="Link" value={b.cta_link||""} onChange={(e)=>updBanner(i,"cta_link",e.target.value)} />
                <button onClick={()=>delBanner(i)} className="text-[#E57373] p-2"><Trash2 className="w-4 h-4" /></button>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-[#F9E1E8] p-5 grid md:grid-cols-2 gap-3">
        <div><label className="text-xs text-[#8C7A80]">Instagram</label><input className="ct w-full" value={s.instagram||""} onChange={(e)=>setS({...s, instagram:e.target.value})} /></div>
        <div><label className="text-xs text-[#8C7A80]">WhatsApp (DDI+DDD+Número)</label><input className="ct w-full" value={s.whatsapp||""} onChange={(e)=>setS({...s, whatsapp:e.target.value})} /></div>
      </div>
      <style>{`.ct{border:1px solid #F9E1E8;background:#FFF9FA;border-radius:12px;padding:10px 14px;outline:none;font-size:14px;color:#4A3B40}.ct:focus{border-color:#C9708B}`}</style>
    </div>
  );
}
